import ExpertShowroomDetail, {
  getStaticProps,
  getStaticPaths,
} from './ShowroomTabPage'

export { getStaticProps, getStaticPaths }

export default ExpertShowroomDetail
